import {
    INSERT_ASSIGNMENT_SUMMARY,
    APPEND_ASSIGNMENT_SUMMARY,
    INSERT_POST_CONFLICT_DEVICES,
    CLEAR_POST_CONFLICT_DEVICES,
    INSERT_CATEGORY,
    INSERT_UNMATCHED_DEVICES,
    APPEND_UNMATCHED_DEVICES,
    INSERT_POST_CONFLICT_USERCONFLICT_DEVICES,
    CLEAR_POST_CONFLICT_USERCONFLICT_DEVICES
  } from '../actions/assignDevicesActions';
  
function assignDevices(
    state = {
          summary:[],
          categoryList:{},
          unmatchedDevices:[],
          postConflictDevices:[],
          postConflictUserConflictDevices:[],
    },
    action
  ) {
    switch (action.type) {
      case INSERT_ASSIGNMENT_SUMMARY:
        return {
            ...state,
          summary: [
            ...action.payload
          ]
        };
        case APPEND_ASSIGNMENT_SUMMARY:
          const tempSummary = state.summary.concat(...action.payload);
          return {
              ...state,
            summary: tempSummary
          };
        case INSERT_CATEGORY:
          return {
              ...state,
              categoryList:{
                ...action.payload
              }
          };
        case INSERT_UNMATCHED_DEVICES:
          return {
              ...state,
            unmatchedDevices: [
              ...action.payload
            ]
          };
        case APPEND_UNMATCHED_DEVICES:
          const tempUnmatched = state.unmatchedDevices.concat(...action.payload);  
          return {
              ...state,
              unmatchedDevices:tempUnmatched
          };

        case INSERT_POST_CONFLICT_DEVICES :
          let tempArr = action.payload.data.length > 0 ? [...action.payload.data] : [];
            return {
                ...state,
                postConflictDevices:tempArr
            };

        case CLEAR_POST_CONFLICT_DEVICES :
          return {
            ...state,
            postConflictDevices:[]
          };

        case INSERT_POST_CONFLICT_USERCONFLICT_DEVICES :
          let temparr = action.payload.data.length > 0 ? [...action.payload.data] : [];
            return {
                ...state,
                postConflictUserConflictDevices:temparr
              };
        
        case CLEAR_POST_CONFLICT_USERCONFLICT_DEVICES:
            return {
                ...state,
                postConflictUserConflictDevices:[]
            };

      default:
        return state;
    }
  }
  export default assignDevices;